import React from "react";
import {
  Box,
  Typography,
  IconButton,
  Stack,
  Link,
  useMediaQuery,
} from "@mui/material";
import { Facebook, Instagram, YouTube, MailOutline } from "@mui/icons-material";
import TikTokIcon from "../../components/TikTokIcon";
import Footer from "../../components/Footer";
import { useNavigate } from "react-router-dom";
import { useTheme } from "@mui/material/styles";

const Home = () => {
  const navigate = useNavigate();
  const theme = useTheme();
  const isMobile = useMediaQuery(theme.breakpoints.down("sm"));

  return (
    <Box sx={{ position: "relative", minHeight: "100dvh", overflow: "hidden" }}>
      {/* 背景（短辺フィット） */}
      <Box
        component="img"
        src={
          isMobile
            ? "/images/top/VisualDesign_tate.jpg"
            : "/images/top/VisualDesign_yoko.jpg"
        }
        alt="bg"
        sx={{
          position: "absolute",
          inset: 0,
          width: "100%",
          height: "100%",
          objectFit: "cover", // 画面の長い方にフィット
          objectPosition: "center",
          zIndex: 0,
          backgroundColor: "#0e2636", // 余白の塗りつぶし
        }}
      />

      {/* 左メニュー */}
      <Box
        sx={{
          position: "absolute",
          left: { xs: 16, sm: 24, md: 40 },
          top: { xs: 16, sm: 32, md: 48 },
          zIndex: 2,
          color: "white",
          fontFamily: `"Times New Roman", Georgia, serif`,
          textShadow: "0 1px 2px rgba(0,0,0,.35)",
        }}
      >
        {/* <Stack spacing={isMobile ? 1 : 2}>
          <Typography
            variant={isMobile ? "h6" : "h5"}
            sx={{ cursor: "pointer" }}
            onClick={() => window.scrollTo({ top: 0, behavior: "smooth" })}
          >
            TOP
          </Typography>
          <Typography
            variant={isMobile ? "h6" : "h5"}
            sx={{ cursor: "pointer" }}
            onClick={() => navigate("/news")}
          >
            NEWS
          </Typography>
          <Typography
            variant={isMobile ? "h6" : "h5"}
            sx={{ cursor: "pointer" }}
            onClick={() => navigate("/live")}
          >
            LIVE
          </Typography>
          <Typography
            variant={isMobile ? "h6" : "h5"}
            sx={{ cursor: "pointer" }}
            onClick={() => navigate("/music")}
          >
            MUSIC
          </Typography>
        </Stack> */}
      </Box>

      {/* 中央コンテンツ */}
      <Box
        sx={{
          position: "relative",
          zIndex: 2,
          minHeight: "100dvh",
          display: "grid",
          placeItems: "center",
          px: 2,
        }}
      >
        <Stack
          alignItems="center"
          spacing={2}
          sx={{ mt: { xs: 2, md: -4 }, color: "white", textAlign: "center" }}
        >
          {/* プロフィール写真（白フレーム） */}
          <Box
            sx={{
              p: 1.5,
              backgroundColor: "white",
              boxShadow: "0 6px 18px rgba(0,0,0,.28)",
              width: { xs: 180, sm: 220, md: 260 },
              aspectRatio: "1 / 1", // 正方形
              overflow: "hidden",
            }}
          >
            <Box
              component="img"
              src="/images/top/VisualPicture.JPEG"
              alt="吉田雪乃"
              sx={{
                width: "100%",
                height: "100%",
                objectFit: "cover", // 切り抜き
              }}
            />
          </Box>

          {/* 名前（日/英） */}
          <Box>
            <Typography
              variant="h4"
              fontWeight="600"
              sx={{
                letterSpacing: 2,
                textShadow: "0 1px 2px rgba(0,0,0,.4)",
              }}
            >
              吉田 雪乃
            </Typography>
            <Typography
              variant="h6"
              fontWeight="bold"
              sx={{
                letterSpacing: 1,
                mb: 1,
                textShadow: "0 1px 2px rgba(0,0,0,.4)",
              }}
            >
              Yukino Yoshida
            </Typography>
          </Box>

          {/* SNS アイコン */}
          <Stack direction="row" spacing={3}>
            <IconButton
              component={Link}
              href="https://www.instagram.com/non.__cmr?igsh=MXkxM3UyYWQ2bXVlNA%3D%3D&utm_source=qr"
              target="_blank"
              sx={{ color: "white" }}
              aria-label="Instagram"
            >
              <Instagram fontSize="large" />
            </IconButton>
            <IconButton
              component={Link}
              href="https://m.facebook.com/yukino.yoshida.315"
              target="_blank"
              sx={{ color: "white" }}
              aria-label="Facebook"
            >
              <Facebook fontSize="large" />
            </IconButton>
            <IconButton
              component={Link}
              href="https://www.tiktok.com/@non.__cmr?is_from_webapp=1&sender_device=pc"
              target="_blank"
              sx={{ color: "white" }}
              aria-label="TikTok"
            >
              <TikTokIcon fontSize="large" />
            </IconButton>
            <IconButton
              component={Link}
              href="https://www.youtube.com/@non.169"
              target="_blank"
              sx={{ color: "white" }}
              aria-label="YouTube"
            >
              <YouTube fontSize="large" />
            </IconButton>
            <IconButton
              component={Link}
              href="https://docs.google.com/forms/d/e/1FAIpQLScN8OMP6xuMOeZ9kxPPYMinwTQS0393ET4L5RJgY_g1q09eZg/viewform?usp=dialog"
              sx={{ color: "white" }}
              aria-label="form"
            >
              <MailOutline fontSize="large" />
            </IconButton>
          </Stack>
        </Stack>
      </Box>
      <Box
        sx={{
          position: "absolute",
          bottom: 0,
          left: 0,
          width: "100%",
          zIndex: 2,
          color: "white",
          background:
            "linear-gradient(180deg, rgba(14,38,54,0) 0%, rgba(14,38,54,0.75) 55%, rgba(14,38,54,0.95) 100%)",
        }}
      >
        <Footer
          sx={{
            marginTop: 0,
            borderTop: "none",
            backgroundColor: "transparent",
            padding: { xs: "16px 16px 24px", md: "20px 24px 32px" },
          }}
          textColor="inherit"
        />
      </Box>
    </Box>
  );
};

export default Home;
